import React from 'react';
import { motion } from 'framer-motion';
import { cardVariants } from '../utils/animations';
import { useTheme, getThemeColors } from '../contexts/ThemeContext';

const Card = ({
  children,
  className = '',
  hover = true,
  glass = true,
  gradient = false,
  onClick,
  ...props
}) => {
  const { isDarkMode } = useTheme();
  const colors = getThemeColors(isDarkMode);

  const baseClasses = 'relative rounded-xl overflow-hidden transition-all duration-300 real-glass';

  const glassClasses = glass
    ? isDarkMode
      ? 'glass-realistic-dark'
      : 'glass-realistic-light'
    : isDarkMode
      ? 'bg-neutral-900 border border-neutral-800'
      : 'bg-white border border-neutral-200';

  const gradientClasses = gradient
    ? 'before:absolute before:inset-0 before:p-[1px] before:bg-gradient-to-r before:from-primary-400 before:to-primary-600 before:rounded-xl before:-z-10'
    : '';

  const classes = `${baseClasses} ${glassClasses} ${gradientClasses} ${className}`;

  // Disable 3D transforms to avoid text blurriness

  return (
    <motion.div
      className={classes}
      onClick={onClick}
      {...props}
    >
      {gradient && (
        <div className={`absolute inset-[1px] rounded-xl z-10 ${colors.bg.card}`} />
      )}

      {/* Multiple glass reflection layers */}
      <div className="absolute inset-0 rounded-xl glass-reflection-1 pointer-events-none" />
      <div className="absolute inset-0 rounded-xl glass-reflection-2 pointer-events-none" />
      <div className="absolute inset-0 rounded-xl glass-reflection-3 pointer-events-none" />

      {/* Edge lighting */}
      <div className="absolute inset-0 rounded-xl glass-edge-light pointer-events-none" />

      {/* Surface texture */}
      <div className="absolute inset-0 rounded-xl glass-surface pointer-events-none" />

      <div className={`relative z-20 ${colors.text.primary}`}>
        {children}
      </div>
    </motion.div>
  );
};

export default Card;
